import { render, staticRenderFns } from "./UserData.vue?vue&type=template&id=2b2b0646"
import script from "./UserData.vue?vue&type=script&lang=ts"
export * from "./UserData.vue?vue&type=script&lang=ts"
import style0 from "./UserData.vue?vue&type=style&index=0&id=2b2b0646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports